import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import './style.css';

const Select = (props) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(undefined);
    const [lastReset, setLastReset] = useState(undefined);

    const {
        defaultSelection,
        name,
        className,
        errors,
        formOnChange,
        onChange,
        options = [],
        placeholder,
        reset,
        touched,
        width
    } = props;

    const classes = classNames(
        className,
        'select-container',
        { 'menu-open': isMenuOpen },
        { 'has-value': selectedOption },
        { 'has-errors': errors && touched }
    );

    const handleChange = (opt) => {
        if (onChange) onChange(opt);
        if (formOnChange) {
            formOnChange({
                type: 'change',
                currentTarget: undefined,
                cancelable: false,
                bubbles: false,
                nativeEvent: new Event('click'),
                defaultPrevented: false,
                eventPhase: 0,
                isTrusted: true,
                preventDefault: () => undefined,
                isDefaultPrevented: () => false,
                stopPropagation: () => undefined,
                isPropagationStopped: () => false,
                persist: () => undefined,
                timeStamp: new Date().getUTCMilliseconds(),
                target: {
                    value: opt.value,
                    name,
                    type: 'text'
                }
            });
        }
        setSelectedOption(opt);
        setIsMenuOpen(false);
        console.log('opt', opt);
    };

    useEffect(() => {
        if (options && !selectedOption && defaultSelection) {
            setSelectedOption(defaultSelection);
        }
    }, [options, defaultSelection]);

    useEffect(() => {
        if (reset && reset !== lastReset) {
            setLastReset(reset);
            setSelectedOption(null);
        }
    });

    return (
        <div className={classes} tabIndex={0} onBlur={() => setIsMenuOpen(false)} style={{ width }}>
            <div className="select">
                <div className="select-trigger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    {placeholder && <div className="select-placeholder">{placeholder}</div>}
                    {selectedOption && <div className="selected-option">{selectedOption?.label}</div>}
                    <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                </div>
                <div className="select-options">
                    {options &&
                        options.map((opt) => (
                            <div className="select-option" key={opt.key} onClick={() => handleChange(opt)}>
                                {opt.label}
                            </div>
                        ))}
                </div>
            </div>
            {touched && errors && <div className="select-errors">{errors}</div>}
        </div>
    );
};

export default Select;
